/*
 * Copyright © 2017 TEKTELIC Communications Inc.
 */

export default angular.module('tektelic.api.integration', [])
    .factory('integrationService', IntegrationService)
    .name;

/*@ngInject*/
function IntegrationService($http, $q) {

    var service = {
        deleteIntegration: deleteIntegration,
        getIntegration: getIntegration,
        saveIntegration: saveIntegration,
        getApplicationIntegrations: getApplicationIntegrations,
        getIntegrationHttpEndpointLink: getIntegrationHttpEndpointLink,
        getRetryStatistics: getRetryStatistics,
        getDeliveryStatistics: getDeliveryStatistics,
        getDlStatistics: getDlStatistics,
        getQueueStatistics: getQueueStatistics
    }

    return service;

    function getApplicationIntegrations (applicationId) {
        var deferred = $q.defer();
        $http.get(`/api/application/${applicationId}/integrations`, null).then(function success(response) {
            deferred.resolve(response.data);
        }, function fail() {
            deferred.reject();
        });
        return deferred.promise;
    }

    function getIntegration (integrationId) {
        var deferred = $q.defer();
        var url = '/api/integration/' + integrationId;
        $http.get(url, null).then(function success(response) {
            deferred.resolve(response.data);
        }, function fail() {
            deferred.reject();
        });
        return deferred.promise;
    }

    function saveIntegration (integration) {
        var deferred = $q.defer();
        var url = '/api/integration';
        $http.post(url, integration).then(function success(response) {
            deferred.resolve(response.data);
        }, function fail() {
            deferred.reject();
        });
        return deferred.promise;
    }

    function deleteIntegration (integrationId) {
        var deferred = $q.defer();
        var url = '/api/integration/' + integrationId;
        $http.delete(url).then(function success() {
            deferred.resolve();
        }, function fail() {
            deferred.reject();
        });
        return deferred.promise;
    }

    function getRetryStatistics(integrationId) {
        var deferred = $q.defer();
        $http.get(`/api/integration/${integrationId}/retry-statistics`, null).then(function success(response) {
            deferred.resolve(response.data);
        }, function fail() {
            deferred.reject();
        });
        return deferred.promise;
    }

    function getDeliveryStatistics(integrationId) {
        var deferred = $q.defer();
        $http.get(`/api/integration/${integrationId}/ul-delivery-statistics`, null).then(function success(response) {
            deferred.resolve(response.data);
        }, function fail() {
            deferred.reject();
        });
        return deferred.promise;
    }

    function getDlStatistics(integrationId) {
        var deferred = $q.defer();
        $http.get(`/api/integration/${integrationId}/dl-statistics`, null).then(function success(response) {
            deferred.resolve(response.data);
        }, function fail() {
            deferred.reject();
        });
        return deferred.promise;
    }

    function getQueueStatistics(integrationId) {
        var deferred = $q.defer();
        $http.get(`/api/integration/${integrationId}/ul-queue-statistics`, null).then(function success(response) {
            deferred.resolve(response.data);
        }, function fail() {
            deferred.reject();
        });
        return deferred.promise;
    }

    function getIntegrationHttpEndpointLink(integrationType, routingKey) {
        var type = integrationType ? integrationType.toLowerCase() : '';
        var key = routingKey ? routingKey : '';
        var version = type.includes('_v2') ? 'v2' : 'v1';
        if (type == 'http_v2') {
            type = 'http'
        }
        return `/api/${version}/integration/${type}/${key}`;
    }

}



// WEBPACK FOOTER //
// ./src/app/api/integration.service.js